import { ActionsUnion, createAction } from 'spw-redux/types';
import {
  GetJoinRequestsParams,
  IJoinRequestsState,
  JoinRequest,
  JoinRequestListItemVM,
  JoinRequestsSortOptions,
  NotificationRequestTotals,
} from './types';

export const GET_JOIN_REQUESTS_FOR_TEAM =
  'joinRequests/GET_JOIN_REQUESTS_FOR_TEAM';
export const GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED =
  'joinRequests/GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED';
export const GET_JOIN_REQUESTS_FOR_TEAM_FAILED =
  'joinRequests/GET_JOIN_REQUESTS_FOR_TEAM_FAILED';

export const GET_JOIN_REQUESTS_FOR_ALL_TEAMS =
  'joinRequests/GET_JOIN_REQUESTS_FOR_ALL_TEAMS';
export const GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED =
  'joinRequests/GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED';
export const GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED =
  'joinRequests/GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED';

export const ACCEPT_TEAM_JOIN_REQUEST = 'joinRequests/ACCEPT_TEAM_JOIN_REQUEST';
export const ACCEPT_TEAM_JOIN_REQUEST_SUCCEEDED =
  'joinRequests/ACCEPT_TEAM_JOIN_REQUEST_SUCCEEDED';
export const ACCEPT_TEAM_JOIN_REQUEST_FAILED =
  'joinRequests/ACCEPT_TEAM_JOIN_REQUEST_FAILED';

export const REJECT_TEAM_JOIN_REQUEST = 'joinRequests/REJECT_TEAM_JOIN_REQUEST';
export const REJECT_TEAM_JOIN_REQUEST_SUCCEEDED =
  'joinRequests/REJECT_TEAM_JOIN_REQUEST_SUCCEEDED';
export const REJECT_TEAM_JOIN_REQUEST_FAILED =
  'joinRequests/REJECT_TEAM_JOIN_REQUEST_FAILED';

export const GET_USER_PENDING_TEAM_REQUESTS =
  'joinRequests/GET_USER_PENDING_TEAM_REQUESTS';
export const GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED =
  'joinRequests/GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED';

export const GET_USER_PENDING_PROJECT_REQUESTS =
  'joinRequests/GET_USER_PENDING_PROJECT_REQUESTS';
export const GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED =
  'joinRequests/GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED';
export const GET_USER_PENDING_PROJECT_REQUESTS_FAILED =
  'joinRequests/GET_USER_PENDING_PROJECT_REQUESTS_FAILED';

export const GET_PROJECT_JOIN_REQUESTS =
  'joinRequests/GET_PROJECT_JOIN_REQUESTS';
export const GET_PROJECT_JOIN_REQUESTS_SUCCEEDED =
  'joinRequests/GET_PROJECT_JOIN_REQUESTS_SUCCEEDED';
export const GET_PROJECT_JOIN_REQUESTS_FAILED =
  'joinRequests/GET_PROJECT_JOIN_REQUESTS_FAILED';

export const ACCEPT_JOIN_REQUEST = 'joinRequests/ACCEPT_JOIN_REQUEST';
export const ACCEPT_JOIN_REQUEST_SUCCEEDED =
  'joinRequests/ACCEPT_JOIN_REQUEST_SUCCEEDED';
export const ACCEPT_JOIN_REQUEST_FAILED =
  'joinRequests/ACCEPT_JOIN_REQUEST_FAILED';

export const REJECT_JOIN_REQUEST = 'joinRequests/REJECT_JOIN_REQUEST';
export const REJECT_JOIN_REQUEST_SUCCEEDED =
  'joinRequests/REJECT_JOIN_REQUEST_SUCCEEDED';
export const REJECT_JOIN_REQUEST_FAILED =
  'joinRequests/REJECT_JOIN_REQUEST_FAILED';

export const GET_USER_PROJECTS_JOIN_REQUESTS =
  'joinRequests/GET_USER_PROJECTS_JOIN_REQUESTS';
export const GET_USER_PROJECTS_JOIN_REQUESTS_SUCCEEDED =
  'joinRequests/GET_USER_PROJECTS_JOIN_REQUESTS_SUCCEEDED';
export const GET_USER_PROJECTS_JOIN_REQUESTS_FAILED =
  'joinRequests/GET_USER_PROJECTS_JOIN_REQUESTS_FAILED';

export const GET_JOIN_REQUESTS_FOR_NOTIFICATIONS =
  'joinRequests/GET_JOIN_REQUESTS_FOR_NOTIFICATIONS';
export const GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED =
  'joinRequests/GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED';

export const CLEAR_JOIN_REQUESTS_REDUCER_BY_KEY =
  'joinRequests/CLEAR_JOIN_REQUESTS_REDUCER_BY_KEY';

export const getJoinRequestsForTeam = (
  id: number,
  params?: GetJoinRequestsParams
) => createAction(GET_JOIN_REQUESTS_FOR_TEAM, { id, params });

export const getJoinRequestsForTeamSucceeded = (results: {
  joinRequests: JoinRequestListItemVM[];
  total: number;
  shouldAppend: boolean;
}) => createAction(GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED, results);

export const getJoinRequestsForTeamFailed = () =>
  createAction(GET_JOIN_REQUESTS_FOR_TEAM_FAILED);

export const getProjectJoinRequests = (
  params: { projectId: number } & GetJoinRequestsParams
) => createAction(GET_PROJECT_JOIN_REQUESTS, params);

export const getProjectJoinRequestsSucceeded = (results: {
  joinRequests: JoinRequestListItemVM[];
  total: number;
  shouldAppend: boolean;
}) => createAction(GET_PROJECT_JOIN_REQUESTS_SUCCEEDED, results);

export const getProjectJoinRequestsFailed = () =>
  createAction(GET_PROJECT_JOIN_REQUESTS_FAILED);

export const getJoinRequestsForAllTeams = (params: GetJoinRequestsParams) =>
  createAction(GET_JOIN_REQUESTS_FOR_ALL_TEAMS, params);
export const getJoinRequestsForAllTeamsSucceeded = (joinRequests: {
  total: number;
  items: JoinRequestListItemVM[];
  shouldAppend: boolean;
}) => createAction(GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED, joinRequests);
export const getJoinRequestsForAllTeamsFailed = () =>
  createAction(GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED);

export const getUserPendingTeamRequests = () =>
  createAction(GET_USER_PENDING_TEAM_REQUESTS);
export const getUserPendingTeamRequestsSucceeded = (
  joinRequestsMap: Record<number, JoinRequest>
) => createAction(GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED, joinRequestsMap);

export const getUserPendingProjectRequests = (projectId?: number) =>
  createAction(GET_USER_PENDING_PROJECT_REQUESTS, { projectId });
export const getUserPendingProjectRequestsSucceeded = (
  joinRequestsMap: Record<number, JoinRequest>
) => createAction(GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED, joinRequestsMap);
export const getUserPendingProjectRequestsFailed = () =>
  createAction(GET_USER_PENDING_PROJECT_REQUESTS_FAILED);

export const getUserProjectsJoinRequests = (payload: {
  page?: number;
  perPage?: number;
  sort?: JoinRequestsSortOptions;
}) => createAction(GET_USER_PROJECTS_JOIN_REQUESTS, payload);
export const getUserProjectsJoinRequestsSucceeded = (joinRequests: {
  total: number;
  items: JoinRequest[];
  shouldAppend: boolean;
}) => createAction(GET_USER_PROJECTS_JOIN_REQUESTS_SUCCEEDED, joinRequests);
export const getUserProjectsJoinRequestsFailed = () =>
  createAction(GET_USER_PROJECTS_JOIN_REQUESTS_FAILED);

export const getJoinRequestsForNotifications = () =>
  createAction(GET_JOIN_REQUESTS_FOR_NOTIFICATIONS);
export const getJoinRequestsForNotificationsSucceeded = (
  totals: NotificationRequestTotals
) => createAction(GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED, totals);

export const acceptTeamJoinRequest = (id: number) =>
  createAction(ACCEPT_TEAM_JOIN_REQUEST, { id });

export const acceptTeamJoinRequestSucceeded = () =>
  createAction(ACCEPT_TEAM_JOIN_REQUEST_SUCCEEDED);

export const acceptTeamJoinRequestFailed = () =>
  createAction(ACCEPT_TEAM_JOIN_REQUEST_FAILED);

export const rejectTeamJoinRequest = (id: number) =>
  createAction(REJECT_TEAM_JOIN_REQUEST, { id });

export const rejectTeamJoinRequestSucceeded = () =>
  createAction(REJECT_TEAM_JOIN_REQUEST_SUCCEEDED);

export const rejectTeamJoinRequestFailed = () =>
  createAction(REJECT_TEAM_JOIN_REQUEST_FAILED);

export const acceptJoinRequest = (
  id: number,
  onRequestCompleted: (requestSucceeded: boolean) => void
) => createAction(ACCEPT_JOIN_REQUEST, { id, onRequestCompleted });

export const acceptJoinRequestSucceeded = () =>
  createAction(ACCEPT_JOIN_REQUEST_SUCCEEDED);

export const acceptJoinRequestFailed = () =>
  createAction(ACCEPT_JOIN_REQUEST_FAILED);

export const rejectJoinRequest = (
  id: number,
  onRequestCompleted: (requestSucceeded: boolean) => void
) => createAction(REJECT_JOIN_REQUEST, { id, onRequestCompleted });

export const rejectJoinRequestSucceeded = () =>
  createAction(REJECT_JOIN_REQUEST_SUCCEEDED);

export const rejectJoinRequestFailed = () =>
  createAction(REJECT_JOIN_REQUEST_FAILED);

export const clearJoinRequestsReducerByKey = (key: keyof IJoinRequestsState) =>
  createAction(CLEAR_JOIN_REQUESTS_REDUCER_BY_KEY, key);

export const actionNames = {
  GET_JOIN_REQUESTS_FOR_TEAM,
  GET_JOIN_REQUESTS_FOR_TEAM_SUCCEEDED,
  GET_JOIN_REQUESTS_FOR_TEAM_FAILED,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS_SUCCEEDED,
  GET_JOIN_REQUESTS_FOR_ALL_TEAMS_FAILED,
  ACCEPT_TEAM_JOIN_REQUEST,
  ACCEPT_TEAM_JOIN_REQUEST_SUCCEEDED,
  ACCEPT_TEAM_JOIN_REQUEST_FAILED,
  REJECT_TEAM_JOIN_REQUEST,
  REJECT_TEAM_JOIN_REQUEST_SUCCEEDED,
  REJECT_TEAM_JOIN_REQUEST_FAILED,
  GET_USER_PENDING_TEAM_REQUESTS,
  GET_USER_PENDING_TEAM_REQUESTS_SUCCEEDED,
  GET_USER_PENDING_PROJECT_REQUESTS,
  GET_USER_PENDING_PROJECT_REQUESTS_SUCCEEDED,
  GET_USER_PENDING_PROJECT_REQUESTS_FAILED,
  GET_PROJECT_JOIN_REQUESTS,
  GET_PROJECT_JOIN_REQUESTS_SUCCEEDED,
  GET_PROJECT_JOIN_REQUESTS_FAILED,
  ACCEPT_JOIN_REQUEST,
  ACCEPT_JOIN_REQUEST_SUCCEEDED,
  ACCEPT_JOIN_REQUEST_FAILED,
  REJECT_JOIN_REQUEST,
  REJECT_JOIN_REQUEST_SUCCEEDED,
  REJECT_JOIN_REQUEST_FAILED,
  GET_USER_PROJECTS_JOIN_REQUESTS,
  GET_JOIN_REQUESTS_FOR_NOTIFICATIONS,
  GET_JOIN_REQUESTS_FOR_NOTIFICATIONS_SUCCEEDED,
};

export const actions = {
  getJoinRequestsForTeam,
  getJoinRequestsForTeamSucceeded,
  getJoinRequestsForTeamFailed,
  getUserPendingTeamRequests,
  getUserPendingTeamRequestsSucceeded,
  getJoinRequestsForAllTeams,
  getJoinRequestsForAllTeamsSucceeded,
  getJoinRequestsForAllTeamsFailed,
  acceptTeamJoinRequest,
  acceptTeamJoinRequestSucceeded,
  acceptTeamJoinRequestFailed,
  rejectTeamJoinRequest,
  rejectTeamJoinRequestSucceeded,
  rejectTeamJoinRequestFailed,
  getUserPendingProjectRequests,
  getUserPendingProjectRequestsSucceeded,
  getUserPendingProjectRequestsFailed,
  getProjectJoinRequests,
  getProjectJoinRequestsSucceeded,
  getProjectJoinRequestsFailed,
  acceptJoinRequest,
  acceptJoinRequestFailed,
  acceptJoinRequestSucceeded,
  rejectJoinRequest,
  rejectJoinRequestFailed,
  rejectJoinRequestSucceeded,
  getUserProjectsJoinRequests,
  getUserProjectsJoinRequestsSucceeded,
  getUserProjectsJoinRequestsFailed,
  getJoinRequestsForNotifications,
  getJoinRequestsForNotificationsSucceeded,
  clearJoinRequestsReducerByKey,
};

export type Actions = ActionsUnion<typeof actions>;
